import OfficeStatusDetailsTable from "./view/OfficeStatusDetailsTable";

const OfficeStatusDetails = () => {
  return (
    <>
      <OfficeStatusDetailsTable />
    </>
  );
};

export default OfficeStatusDetails;
